import React, { FunctionComponent } from 'react';

import { Modal } from 'components';
import { Text, Heading } from 'components/chroma';

const HelpTextModal: FunctionComponent<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => (
  <Modal
    header="What does Market and Agreed value mean?"
    isOpen={isOpen}
    onClose={onClose}
  >
    <Heading size={2} margin={{ bottom: 1 }}>
      Market Value
    </Heading>
    <Text>
      Market Value means our assessment of the value of the car immediately
      prior to the incident you are claiming for. We use local market prices and
      consider the age and condition of the car. It includes any modifications,
      options or accessories that are fitted to the car, GST, registration and
      any Compulsory Third Party (CTP) insurance, and other on-road costs.
      Market Value doesn’t include allowance for dealer profit, warranty costs,
      future stamp duty and transfer fees
    </Text>
    <Heading size={2} margin={{ bottom: 1 }}>
      Agreed Value
    </Heading>
    <Text>
      Agreed Value means the amount we agree to insure your car for during the
      current period of insurance. It includes any modifications, options or
      accessories that are fitted to the car, GST, registration and any
      Compulsory Third Party (CTP) insurance, and other on-road costs. Agreed
      Value doesn’t include allowance for dealer profit, warranty costs, future
      stamp duty and transfer fees. As most cars depreciate with age and use,
      the Agreed Value will almost always reduce when your policy is renewed.
    </Text>
  </Modal>
);

export default HelpTextModal;
